function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import { WDHImage } from '@demant/wdh';
import { CSSTransition } from 'react-transition-group';
import { onResize } from "@demant/wdh";
var FrontpageSectionMenu = /*#__PURE__*/function (_React$Component) {
  function FrontpageSectionMenu(props) {
    var _this;
    _classCallCheck(this, FrontpageSectionMenu);
    _this = _callSuper(this, FrontpageSectionMenu, [props]);
    _this.state = {};
    _this.props.settings.elements.forEach(function (element, index) {
      _this.state["setImageHeight".concat(index)] = false;
    });
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    return _this;
  }
  _inherits(FrontpageSectionMenu, _React$Component);
  return _createClass(FrontpageSectionMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      onResize(function () {
        var li = Array.from(document.querySelectorAll('.image-spot.as-sectionmenu li'));
        li.forEach(function (item) {
          item.style.height = '';
        });
        setTimeout(function () {
          li.forEach(function (item) {
            item.style.height = "".concat(item.offsetHeight, "px");
          });
        }, 0);
      });
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event, index) {
      var newState = {};
      newState["setImageHeight".concat(index)] = true;
      this.setState(newState);
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut(event, index) {
      var newState = {};
      newState["setImageHeight".concat(index)] = false;
      this.setState(newState);
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia("(min-width:1025px)").matches;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var settings = this.props.settings;
      var sectionMenuList = settings.elements || [];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
        className: "image-spot-elements"
      }, sectionMenuList.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: "image-spot-element",
          key: index,
          onMouseOver: function onMouseOver(evt) {
            _this2.handleMouseOver(evt, index);
          },
          onMouseOut: function onMouseOut(evt) {
            _this2.handleMouseOut(evt, index);
          },
          onFocus: function onFocus(evt) {
            _this2.handleMouseOver(evt, index);
          },
          onBlur: function onBlur(evt) {
            _this2.handleMouseOut(evt, index);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "scLooseFrameZone",
          sc_item: item.sitecoreItem || ''
        }, /*#__PURE__*/React.createElement("span", {
          className: "scChromeData"
        }, item.sitecoreChromeData || ''), /*#__PURE__*/React.createElement("a", {
          href: item.link.href
        }, /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-image",
          style: _this2.isDesktop() ? _this2.state["setImageHeight".concat(index)] ? {
            maxHeight: "291px"
          } : {
            maxHeight: "461px"
          } : null
        }, /*#__PURE__*/React.createElement(WDHImage, {
          image: item.image.image
        })), /*#__PURE__*/React.createElement("div", {
          className: "disc-down"
        }, /*#__PURE__*/React.createElement("span", null, "\uE603")), /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-text-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-header"
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: item.header
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-link"
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: item.link.content
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-text"
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: item.text
          }
        }))))));
      })));
    }
  }]);
}(React.Component);
export default FrontpageSectionMenu;